import type { IMasterDataProductPriceRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataProductPricesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataProductPricesUseCase {
  private readonly repository: IMasterDataProductPriceRepository;

  constructor(repository: IMasterDataProductPriceRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataProductPricesDTO) {
    return this.repository.getProductPrices(params);
  }
}
